import React from "react";

const Render = (props, context) => {
  
  return (
    <div>
      {props.goal.buyersPoints > 0 && (
        <div>
          <p className="pRel monto horizontalCenter mtm violet mbs">
            <span className="violet">Compradores: {props.goal.buyers}</span> 
            <span className="violet"> {Math.round(((props.goal.buyersProgress) * 1000) / props.goal.buyers)/10}%</span>
          </p>
          <progress
            max={100}
            value={((props.goal.buyersProgress) * 100) / props.goal.buyers}
          >
            <div className="progressBar ">
              <span
                style={{
                  width: `${parseInt(
                    (props.goal.buyersProgress) / props.goal.buyers,
                    10
                  )}%`
                }}
              />
            </div>
          </progress> 
          {props.goal.buyers > props.goal.buyersProgress && (
            <div>
              <p className="horizontalCenter ptm violet uppercase bold txs">Te faltan <span>{props.goal.buyers - props.goal.buyersProgress}</span> compradores y</p>
              <p className="horizontalCenter violet uppercase bold">ganás {props.goal.buyersPoints} puntos</p>
            </div>
          )}
          {props.goal.buyers === props.goal.buyersProgress && (
            <div>
              <p className="horizontalCenter ptm violet uppercase bold txs">Alcanzaste el objetivo de <span>{props.goal.buyers}</span></p>
              <p className="horizontalCenter violet uppercase bold">Ganaste {props.goal.buyersPoints} puntos</p>
            </div>
          )}
          {props.goal.buyers < props.goal.buyersProgress && (
            <div>
              <p className="horizontalCenter ptm violet uppercase bold txs">Superaste el objetivo por <span>{props.goal.buyersProgress - props.goal.buyers}</span></p>
              <p className="horizontalCenter violet uppercase bold">Ganaste {props.goal.buyersPoints} puntos</p>
            </div>
          )}
        </div>
      )}
      {props.goal.quantity > 0 && (
        <div>
          <p className="pRel monto horizontalCenter mtm violet mbs">
            <span className="violet">{props.unitsPre} {props.goal.quantity} {props.units}</span>
            <span className="violet">{Math.round(((props.goal.quantityProgress) * 1000) / props.goal.quantity)/10}%</span>
          </p>
          <progress
            max={100}
            value={((props.goal.quantityProgress) * 100) / props.goal.quantity}
          >
            <div className="progressBar ">
              <span
                style={{
                  width: `${parseInt(
                    (props.goal.quantityProgress) / props.goal.quantity,
                    10
                  )}%`
                }}
              />
            </div>
          </progress> 
          {props.goal.quantity > props.goal.quantityProgress && (
            <div>
              <p className="horizontalCenter violet uppercase bold txs">Te faltan <span>{props.unitsPre} {props.goal.quantity - props.goal.quantityProgress}</span> {props.units} y</p>
              <p className="horizontalCenter pbm violet uppercase bold">Ganás {props.goal.quantityPoints} puntos</p>
            </div>
          )}
          {props.goal.quantity === props.goal.quantityProgress && (
            <div>
              <p className="horizontalCenter violet uppercase bold txs">Alcanzaste el objetivo de <span>{props.unitsPre} {props.goal.quantity} {props.units}</span></p>
              <p className="horizontalCenter pbm violet uppercase bold">Ganaste {props.goal.quantityPoints} puntos</p>
            </div>
          )}
          {props.goal.quantity < props.goal.quantityProgress && (
            <div>
              <p className="horizontalCenter violet uppercase bold txs">Superaste el objetivo por <span>{props.unitsPre} {props.goal.quantityProgress - props.goal.quantity} {props.units}</span></p>
              <p className="horizontalCenter pbm violet uppercase bold">Ganaste {props.goal.quantityPoints} puntos</p>
            </div>
          )}          
          <hr></hr>
        </div>
      )}
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DesafiosObjetivos/Objetivo.js